<template>
	<div>
		<div class="top_box">
			<h2>已启动救援案件管理</h2>
			<div class="time_box">
				<div class="block st_box">
					起始时间
					<el-date-picker @change="sttime()" v-model="st_time" align="right" type="date" placeholder="起始时间" :picker-options="pickerOptions1"></el-date-picker>
				</div>
				<div class="block en_box">
					结束时间
					<el-date-picker @change="entime()" v-model="en_time" align="right" type="date" placeholder="结束时间" :picker-options="pickerOptions1"></el-date-picker>
				</div>
         <div class="block en_box">
                    保单号：
                     <el-input style="display: inline-block;width: 220px;" @change="sttime()" v-model="victimPolicyNo" placeholder="请输入内容"></el-input>
                </div>
                  <div class="block en_box">
                    被保险人：
                     <el-input style="display: inline-block;width: 220px;" @change="sttime()"  v-model="victimUser" placeholder="请输入内容"></el-input>
                </div>
                  <div class="block en_box" style="margin-left:0px">
                    证件信息：
                     <el-input style="display: inline-block;width: 220px;" @change="sttime()"  v-model="victimNational" placeholder="请输入内容"></el-input>
                </div>
				<div class="block"><el-button type="primary" @click="filt()">查询</el-button></div>
			</div>
		</div>
		<div class="form_box">
			<el-table :data="tableData" empty-text="暂无数据" border>
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<div
								class="textBox"
								v-for="(v, i) in tableData[props.$index].list"
								:key="i"
								v-if="props.row.state == 120 || props.row.state == 130 || props.row.state == 140 || v.bidding.state == 2"
							>
								<span class="tableName" :title="v.insti.name">{{ v.insti.name }}</span>
								<span v-if="v.solution">
									<span>
										整体报价:
										<span class="testColor">{{ v.solution.totalFee || 0 }} {{ v.solution.currency }}</span>
									</span>
									<span>
										救援费用:
										<span class="testColor">{{ v.solution.rescueFee || 0 }} {{ v.solution.currency }}</span>
									</span>
									<span>
										医疗费用:
										<span class="testColor">{{ v.solution.medicFee || 0 }} {{ v.solution.currency }}</span>
									</span>
									<span>
										案件服务费用:
										<span class="testColor">{{ v.solution.caseFee || 0 }} {{ v.solution.currency }}</span>
									</span>
								</span>
								<span v-if="props.row.state == 140 && v.bidding.state == 0">等待报价</span>
								<span v-if="props.row.state == 140 && v.bidding.state == 1">已报价</span>
								<!--span v-if="props.row.state==140&& v.bidding.state ==2">
                  已通过
                </span -->
								<span v-if="v.bidding.state == 3">已关闭</span>
								<span v-if="props.row.state == 150 && v.bidding.state == 2">(费用等待审核)</span>
								<span v-if="props.row.state == 160 && v.bidding.state == 2">(费用审核通过)</span>
								<!-- <span v-if="props.row.state==160">
                  开始救援
                </span> -->
								<span class="span_box" @click="pass(props.row.caseid, v)" v-if="props.row.state == 160 && v.bidding.state == 2">授权该救援机构开始救援</span>
								<!-- <span class="span_box" @click="adopt(v.bidding.solutionNo,props.row)" v-if="props.row.state==140 && v.bidding.state==1">
                  同意该公司报价转交保险授权</span> -->
								<span class="span_box" @click="toplook(props.row.caseid, v.bidding.id)" v-if="typeof v.solution != 'undefined'">报价详情</span>
								<span
									class="span_box"
									@click="
										closeArr = v.bidding.solutionNo;
										closeArr1 = props.row;
										expVisible1 = true;
									"
									v-if="props.row.state == 140 && (v.bidding.state == 1 || v.bidding.state == 0)"
								>
									关闭报价
								</span>
								<span
									class="span_box"
									@click="
										exp(props.row.stateText3);
										expVisible = true;
									"
									v-if="props.row.state == 160 && v.bidding.state == 2"
								>
									授权说明
								</span>
							</div>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="number" label="序号" min-width="50" type="index" :index="1"></el-table-column>
				<el-table-column prop="casenumber" label="案件编号" min-width="80"></el-table-column>
				<el-table-column prop="address" label="案件地点" min-width="80"></el-table-column>
				<el-table-column prop="username" label="用户信息" min-width="90"></el-table-column>
				<el-table-column prop="papers" label="证件信息" min-width="90"></el-table-column>
				<el-table-column prop="open" label="案件来源" min-width="50"></el-table-column>
				<el-table-column prop="plan" label="案件状态" min-width="100"></el-table-column>
				<el-table-column prop="par" label="用户是否投保" min-width="90">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">保险详情</el-button>
						<el-button type="text" size="small" v-show="!scope.row.isshow">无</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="get_time" label="启动救援时间" min-width="110"></el-table-column>
				<el-table-column prop="el" label="其他" min-width="90%">
				  <template slot-scope="scope">
				    <el-button type="text" size="small" @click="dialogVisible=true;closeId=scope.row.caseid">关闭当前案件</el-button>
				  </template>
				</el-table-column>
				<el-table-column prop="op" label="操作" min-width="160">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="topinf(scope.row.initialCaseId)">案件详情</el-button>
						<el-button v-if="scope.row.state == 130" type="text" size="small" @click="topar(scope.row.caseid, scope.$index)">转交救援公司获取报价</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
    <el-pagination
      style="margin-top: 15px;float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[10]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
		<el-dialog title="授权说明" :visible.sync="expVisible" class="exp_dialog" width="50%" center>
			<p style="text-align:center">{{ exptxt }}</p>
		</el-dialog>
		<el-dialog title="确认删除" :visible.sync="expVisible1" class="exp_dialog" width="50%" center>
			<div style="text-align: right;">
				<button
					class="btn1"
					@click="
						reject(closeArr, closeArr1);
						expVisible1 = false;
					"
				>
					确认
				</button>
				<button class="btn2" @click="expVisible1 = false">取消</button>
			</div>
		</el-dialog>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认关闭？</span>
      <textarea placeholder="请输入关闭原因" v-model="closeTxt" class="closeTxt"></textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;closeCase(closeId)">确 定</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
import qs from 'qs';
import funVue from './fun.vue';
import { Message } from 'element-ui';
import err from '@/util/error2msg.js';
import 'isomorphic-fetch';
import constants from '@/util/constants.js';
import { closeOrdinaryCase } from '@/views/axios/api.js'
export default {
	data() {
		return {
       start:0,
        count:10,
        total:0,
        currentPage4: 1,
        victimUser:'',
        victimPolicyNo:'',
        victimNational:'',
			closeArr: '',
			closeArr1: '',
			typeId: this.$route.query.typeId,
			tableData: [],
			expVisible: false,
			expVisible1: false,
			exptxt: '',
			obj: [],
			victimList: [],
			token:JSON.parse(window.localStorage.getItem('data')).data,
			st_time: '',
			en_time: '',
			pickerOptions1: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			},
      dialogVisible:false,
      closeId:'',
      closeTxt:''
		};
	},
	methods: {
    handleSizeChange(val) {
         this.count = val
             this.getData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.start = (val-1) * this.count;
        // this.start = val * 10
            this.getData()
        console.log(`当前页: ${val}`);
      },
		error2msg(errcode) {
			var errmsg = err;
			var msg = errmsg.tomsg(errcode);
			Message.error(msg);
		},
		exp(txt) {
			if (this.languageIndex == 0) {
				this.exptxt = constants.setTxt(txt, 'zh');
			} else {
				this.exptxt = constants.setTxt(txt, 'en');
			}
		},
    closeCase(){
      var data={
        token:this.token,
        caseId:this.caseid
      }
      closeOrdinaryCase(data)
      .then(res => {
        console.log(res);
        if(res.data.code == 0){
          this.$message.success('案件已关闭')
          this.getData()
        }
      })
      .catch(err => {
        console.log(err);
      })
    },
		pass(caseid, v) {
			v.state = 160;
			this.axios
				.post(
					constants.domain + 'rescue/bidding/authorize_rescue_start ',
					qs.stringify({
						token: this.token,
						caseId: caseid
					})
				)
				.then(res => {
					if (res.data.code == 0) {
						Message({
							message: '操作成功',
							type: 'success'
						});
						// this.$router.push({
						//   name: "ComOffer",
						//   params: {
						//     time: new Date()
						//   },
						//   query: {
						//     typeId:this.typeId
						//   }
						// });
						window.location.reload();
					} else {
						this.error2msg(res.data.code);
					}
				});
			// this.$router.go(0)
		},
		adopt(solutionNo, v) {
			v.state = 150;
			this.axios
				.post(
					constants.domain + 'rescue/bidding/update_bidding_state',
					qs.stringify({
						token: this.token,
						solutionNo,
						status: 1
					})
				)
				.then(res => {
					if (res.data.code == 0) {
						Message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.push({
							name: 'ComOffer',
							params: {
								time: new Date()
							},
							query: {
								typeId: this.typeId
							}
						});
					} else {
						this.error2msg(res.data.code);
					}
				});
		},
		reject(solutionNo, v) {
			this.axios
				.post(
					constants.domain + 'rescue/bidding/update_bidding_state',
					qs.stringify({
						token: this.token,
						solutionNo,
						status: 2
					})
				)
				.then(res => {
					if (res.data.code == 0) {
						Message({
							message: '操作成功',
							type: 'success'
						});
						this.getData();
					} else {
						this.error2msg(res.data.code);
					}
				});
		},
		topinf(obj) {
      this.$router.push({
        path: '/cmd_center/caseDetails',
        query: {
          caseid: obj
        },
      });
      return
			let that = this;
			that.victimList.map((v, i) => {
				if (v.obj.caseId == obj) {
					this.$router.push({
						name: 'ComPar',
						params: {
							token: that.token,
							obj: that.obj,
							victimList: that.victimList,
							index: i
						},
						query: {
							typeId: this.typeId,
							caseid: obj
						}
					});
				}
			});
		},
		toplook(obj, bidId) {
			this.$router.push({
				name: 'Comlookinf',
				params: {
					token: this.token
				},
				query: {
					typeId: this.$route.query.typeId,
					caseid: obj,
					bidId: bidId
				}
			});
		},
		topar(obj, index) {
			this.$router.push({
				name: 'helpCompany',
				params: {
					token: this.token,
					index,
					obj: this.obj,
					victimList: this.victimList
				},
				query: {
					typeId: this.$route.query.typeId,
					caseid: obj
				}
			});
		},
		toUrl(url) {
			window.open(url);
		},
		filt() {
		 this.getData(this.st_time,this.en_time)
		},
		sttime() {
			this.st_time = this.st_time * 1;
			// this.getData(this.st_time, 0);
			// console.log(this.st_time);
		},
		entime() {
			this.en_time = this.en_time * 1;
			// this.getData(0, this.en_time);
		},
		getData(st, et) {
			this.tableData = [];
			let that = this;
			let n = 0;
			let sex = '';
			let isshow = false;
			let stTime = st || this.st_time;
			let enTime = et || this.en_time;
			let plan = '';
			let list = [];
			let tl = '';
			if (stTime && enTime) {
				tl = tl + `&startTs=${stTime}&endTs=${enTime}`;
			}

			let nl = 0;

			fetch(constants.domain + 'rescue/case/list_case', {
				method: 'POST',
				body: `token=${this.token}&typeId=${this.typeId}&status=120&status=130&status=140&status=150&status=160&victimUser=${this.victimUser}&victimPolicyNo=${this.victimPolicyNo}&victimNational=${this.victimNational}&start=${this.start}&count=${this.count}` + tl,
				mode: 'cors',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			})
				.then(function(res) {
					console.log('请求了offer no start');
					return res.json();
				})
				.then(function(data) {
					if (data.obj) {
             that.total = data.total
						data.obj.map((v, i) => {
							async function getout(state) {
								that.axios
									.post(
										constants.domain + 'rescue/bidding/list_bidding',
										qs.stringify({
											token: that.token,
											caseId: v.obj.id
										})
									)
									.then(res => {
										list = res.data.obj;
										if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != '') {
											isshow = true;
										} else {
											isshow = false;
										}

										var pt = constants.pt2txt2(state);
										var address = '';
										if (v.generalLocation) {
											if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
												address = v.generalLocation.addr;
											} else {
												address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en');
											}
										}
										that.tableData.push({
											state: v.obj.caseState,
											caseid: v.obj.id,
                      initialCaseId:v.obj.initialCaseId,
											stateText3: v.obj.stateText3 || '',
											number: i + 1, //序号
											casenumber: v.obj.caseNo, //案件编号
											address, //地址
											username: v.victimList[0].obj.victimName + (v.obj.reporterContact || ''), //用户信息
											papers: v.victimList[0].obj.idNo || '无', //身份证号
											plan: pt.phase, //状态
											open: v.obj.caseSrc,
											node: pt.node,
											get_time: constants.time(v.obj.incidentTs),
											op: '查看并操作',
											insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
											isshow: isshow,
											list: list,
											w: v.obj.updateAt
										});
										nl--;
										if (nl == 0) {
											console.log('sortting!!');
											that.tableData.sort(sortcase);
										}
									});
							}
							if (v.victimList[0].obj.gender == '1') {
								sex = '男';
							} else {
								sex = '女';
							}
							if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != '') {
								isshow = true;
							} else {
								isshow = false;
							}
							var pt = constants.pt2txt2(v.obj.caseState);
							if (v.obj.caseState == 140 || v.obj.caseState == 150 || v.obj.caseState == 160) {
								nl++;
								getout(v.obj.caseState);
							} else {
								var address = '';
								if (v.generalLocation) {
									if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
										address = v.generalLocation.addr;
									} else {
										address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en');
									}
								}

								that.tableData.push({
									state: v.obj.caseState,
									caseid: v.obj.id,
                  initialCaseId:v.obj.initialCaseId,
									stateText3: v.obj.stateText3 || '无',
									number: i + 1, //序号
									casenumber: v.obj.caseNo, //案件编号
									address, //地址
									username: v.victimList[0].obj.victimName + (v.obj.reporterContact || ''), //用户信息
									papers: v.victimList[0].obj.idNo, //身份证号
									plan: pt.phase, //进度
									node: pt.node, //节点
									isshow: isshow,
									open: v.obj.caseSrc,
									get_time: constants.time(v.obj.incidentTs),
									op: '查看并操作',
									insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
									w: v.obj.updateAt
								});
							}
							that.caseid = v.obj.id;
							that.obj.push(v.obj);
							that.victimList.push(v.victimList[0]);
						});
					}
				});
		}
	},
	mounted() {
		window.localStorage.setItem(
			'case',
			JSON.stringify({
				case: 'Comoffer'
			})
		);
		this.getData();
	},
	computed: {
		languageIndex() {
			return this.$store.state.language;
		}
	},
	watch: {
		languageIndex() {
			this.getData();
		}
	}
};

function sortcase(a, b) {
	return b.w - a.w;
}
</script>

<style scoped>
@import url('../../css/table.css');
.tableName {
	display: inline-block;
	width: 150px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.textBox {
	overflow: hidden;
	margin-top: 10px;
}
.textBox > span {
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
}
.span_box {
	color: #409eff;
	cursor: pointer;
}
.btn1,
.btn2 {
	width: 100px;
	height: 40px;
	background: #409eff;
	color: white;
	border: none;
	cursor: pointer;
}
.btn2 {
	background: #ccc;
}
.testColor {
	color: #ff7200;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/Offer.vue